import { render, staticRenderFns } from "./TipoValidacao.vue?vue&type=template&id=b1f8ef68&scoped=true"
import script from "./TipoValidacao.vue?vue&type=script&lang=js"
export * from "./TipoValidacao.vue?vue&type=script&lang=js"
import style0 from "./TipoValidacao.vue?vue&type=style&index=0&id=b1f8ef68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f8ef68",
  null
  
)

export default component.exports